import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { storeOnsiteInterviews, type IRawOnsiteInterview } from '~/actions/PermanentJobs';
import { TOnsiteInterviewFormData } from '../../components';
import { CreateOnsiteInterviewSteps } from '../Types';
import { useSafeLocationState } from './useSafeLocationState';
import { fireInterviewRequestNextClicked } from '~/posthogs/events';
import { TRootState } from '~/store/types';

export const useStoreOnsiteInterview = (jobPostingId: string | undefined) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSafeLocationState();

  // Get existing interviews count for this job posting
  const existingInterviews = useSelector((state: TRootState) =>
    jobPostingId ? state.permanentJobs.onsiteInterviews[jobPostingId] || [] : [],
  );

  const onSubmit = (formData: TOnsiteInterviewFormData) => {
    if (!jobPostingId) {
      return;
    }

    const payload = {
      breakTime: formData.breakTime,
      dates: formData.dates,
      hourlyRate: formData.hourlyRate,
      hoursArrival: formData.hoursArrival,
      hoursDeparture: formData.hoursDeparture,
      isAssistedHygiene: formData.isAssistedHygiene,
      isPaidBreakTime: formData.isPaidBreakTime,
      profession: formData.profession,
      professionals: formData.professionals,
      specialty: formData.specialty,
    } satisfies IRawOnsiteInterview;

    // Store onsite interviews (smart merge: appends if exists, creates if empty)
    dispatch(storeOnsiteInterviews(jobPostingId, payload));

    // Track the interview request next clicked event
    // Adding N to existing count since we're adding a new interviews
    fireInterviewRequestNextClicked({
      postingId: jobPostingId,
      interviewCount: existingInterviews.length + formData.dates.length,
    });

    navigate(
      // eslint-disable-next-line max-len
      `/permanent-jobs/postings/${jobPostingId}/onsite-interviews/create/${CreateOnsiteInterviewSteps.Reviews}`,
      { state },
    );
  };

  return {
    onSubmit,
  };
};
